export default __webpack_public_path__ + "static/media/Pencil Drawing.92433e9a.svg";